import React from 'react';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemDanToc} from './datatable/list';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {Input, TextArea} from 'components/tt-forms/common';
import {MasterLayout} from 'layout';
class DanToc extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isSubmit: false,
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryCode: '',
      categoryDesc: '',
      maTTCP: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false
    };
  }

  componentDidMount() {
    this.getListData();
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getDanToc.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.danTocs,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        if(this.state.pageData.number > 0){
          this.state.pageData.number -= 1;
          this.getListData();
        }
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  createCategory() {
    if(this.validateSubmitForm()){
      let params = {
        ten: this.state.categoryName.trim(),
        ma: this.state.categoryCode.trim(),
        tenKhac: this.state.categoryNameOther.trim(),
        moTa: this.state.categoryDesc.trim(),
        maTTCP: this.state.maTTCP.trim(),
      };
      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        this.props.danhMuc.updateDanToc({id: this.state.categoryId},params).then(res => {
          this.getListData();
          this.closeDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        this.props.danhMuc.postDanToc('',params).then(res => {
          this.getListData();
          this.closeDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
    }
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(categoryId) {
    if(categoryId){
      this.setState({buttonLoading: true});
      this.props.danhMuc.deleteDanToc({id: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail,'error');
          this.setState({buttonLoading: false});
        }
      });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  openDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
  }

  closeDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    //
  }

  openAddNewCategory() {
    this.openDialog();
    this.setState({
      addType:0,
      categoryName: '',
      categoryCode: '',
      categoryNameOther: '',
      categoryDesc: '',
      maTTCP: '',
      isValid: true
    });
  }

  openUpdateCategory(item) {
    this.openDialog();
    this.setState({
      addType:2,
      categoryId: item.danTocId,
      categoryName: item.ten,
      categoryCode: item.ma,
      categoryNameOther: item.tenKhac,
      categoryDesc: item.moTa,
      maTTCP: item.maTTCP,
      isValid: true
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div className="center reception-container">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-reception"></i>Dân tộc</p>
          </div>
          <div className="right-content">
            {
              CheckPermission('DANTOC_THEM') ?
                <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
              : null
            }
          </div>
        </div>
        <div className="bottom-content">
          <Search parents={this}/>
          <DataTable
            header = {header.categoryGroup.nation}
            dataList={this.state.data}
            pageData={this.state.pageData}
            hideButtonExport
            parent= {this}
            tableLoading = {this.state.tableLoading}
          >
           <RowItemDanToc/>
          </DataTable>
        </div>
        <Dialog
          isOpen={this.state.popupAddCategory}
          onClose={this.closeDialog.bind(this)}
          title={this.state.addType == 2 ? 'Chỉnh sửa dân tộc' : 'Thêm mới dân tộc'}
          iconName="add-new"
          className="panel-popup category">
          <div className="pt-dialog-body">
            <Input className="col-6" label="Tên" value={this.state.categoryName} bindValidator={this} channel="formTaoDon" require maxLength={40} onChange={this.onChange.bind(this, 'categoryName')}/>
            <Input className="col-6" label="Mã" value={this.state.categoryCode} bindValidator={this} channel="formTaoDon" require maxLength={40} onChange={this.onChange.bind(this, 'categoryCode')}/>
            <Input className="col-6" label="Mã TTCP" value={this.state.maTTCP} require={false} maxLength={40} onChange={this.onChange.bind(this, 'maTTCP')} channel="danhMuc"/>
            <Input className="col-6" label="Tên khác" value={this.state.categoryNameOther} maxLength={40} onChange={this.onChange.bind(this, 'categoryNameOther')} />

            <TextArea label="Mô tả" rows={5} maxLength={255} value={this.state.categoryDesc} onChange={this.onChange.bind(this, 'categoryDesc')} className='col-12'/>
          </div>
          <div className="pt-dialog-footer">
            <Link onClick={this.closeDialog.bind(this)} className="btn-action btn-close" >
              <span>Đóng</span>
            </Link>
            <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
              <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
            </Link>
          </div>
        </Dialog>
      </div>
      </MasterLayout>
    );
  }
}

DanToc.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(DanToc);



// WEBPACK FOOTER //
// ./src/components/modules/category/DanToc.jsx